import SetSystemMessageScreen from "./SetSystemMessageScreen";

export default SetSystemMessageScreen;